<template>
  <v-autocomplete
    :prepend-inner-icon="prepend_inner_icon"
    :items="clients"
    item-text="nome"
    item-value="id"
    :search-input.sync="filter"
    :loading="loading"
    no-filter
    :value="client"
    @input="$emit('change', $event)"
    v-bind="$attrs"
    :no-data-text="getNoDataMessage()"
    allow-overflow
    :error-messages="error_messages"
  >
    <template v-slot:item="{ item, attrs, on }">
      <v-list-item v-bind="attrs" v-on="on" two-lines>
        <v-list-item-content>
          <v-list-item-title> {{ item.nome }} </v-list-item-title>
          <v-list-item-subtitle>
            {{ item.contato1 }} <span class="ml-2"> {{ item.contato2 }} </span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      <v-list-item two-lines v-if="!single_response">
        <v-list-item-content>
          <v-list-item-title> {{ item.nome }} </v-list-item-title>
          <v-list-item-subtitle>
            {{ item.contato1 }} <span class="ml-2"> {{ item.contato2 }} </span>
          </v-list-item-subtitle>
          <v-list-item-subtitle v-if="show_available_credit">
            <span
              :class="{
                'green--text': item.credito_disponivel > 0,
                'red--text': item.credito_disponivel <= 0,
              }"
              >{{ formatMoney(item.credito_disponivel) }}</span
            >
            disponível
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <span v-else> {{ item.nome }} </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { index as indexClients, show as showClient } from "@/services/clients";
import MoneyMixin from "@/mixins/MoneyMixin";

export default {
  name: "client-picker",
  mixins: [MoneyMixin],
  model: {
    prop: "client",
    event: "change",
  },
  props: {
    client: {
      default: null,
    },
    show_available_credit: {
      default: false,
      type: Boolean,
    },
    error_messages: {
      default: () => [],
      type: Array,
    },
    prepend_inner_icon: {
      default: "mdi-magnify",
      type: String,
    },
    single_response: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    clients: [],
    filter: null,
    loading: false,
    total_clients: 0,
    options: {},
    actual_clients_page: 1,
    typping: false,
  }),
  methods: {
    getNoDataMessage() {
      if (!!!this.filter) {
        return "Digite para prourar um cliente";
      } else if (this.typping) {
        return "Digitando...";
      } else {
        return this.loading ? "Carregando..." : "Nenhum cliente encontrado.";
      }
    },
    async getClients(filter) {
      const options = {
        sortBy: ["nome"],
        sortDesc: false,
        page: 1,
        itemsPerPage: 50,
      };

      this.actual_clients_page = 1;

      this.loading = true;
      try {
        const response = await indexClients(options, filter);
        this.clients = response.data;
        this.total_clients = response.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    filter: _.debounce(async function (value, old_Value) {
      console.log(value);
      if (value) this.getClients(value);
    }, 500),
    client: function (value, old) {
      if (!old) {
        this.getClients(value);
      }
    },
  },
  created() {
    console.log("client", this.client);
    this.getClients(this.client);
  },
};
</script>